import React from 'react'
import { CheckCircle, Target, Users, Zap } from 'lucide-react'

export default function Expertise() {
  const features = [
    {
      icon: Target,
      title: "End-to-End Solutions",
      description: "From concept to deployment, we handle every aspect of your project"
    },
    {
      icon: Zap,
      title: "Rapid Development",
      description: "Fast turnaround times without compromising on quality"
    },
    {
      icon: Users,
      title: "Expert Team",
      description: "Seasoned professionals with diverse industry experience"
    },
    {
      icon: CheckCircle,
      title: "Proven Results",
      description: "Successfully delivered projects across multiple sectors"
    }
  ];

  return (
    <section className='w-full py-20 bg-gradient-to-br from-blue-50 to-indigo-100'>
      <div className="bl-container">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className='text-4xl md:text-5xl font-bold text-gray-900 mb-6'>
            Our Expertise
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
          <p className='text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed'>
            At RamdhuniTech Venture, we bring ideas to life with end-to-end software development 
            tailored to your business needs. From intuitive user experiences to scalable backend 
            systems, our expert team crafts solutions that drive growth and efficiency. Whether 
            it's web, mobile, or desktop, we've empowered clients in hospitality, HR, and 
            e-commerce to achieve their digital goals.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index}
                className="group bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="p-3 bg-blue-50 rounded-full mb-4 group-hover:bg-blue-100 transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Statistics */}
        <div className="bg-white rounded-2xl p-8 shadow-xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="group">
              <div className="text-4xl font-bold text-blue-600 mb-2 group-hover:scale-110 transition-transform duration-300">
                100+
              </div>
              <p className="text-gray-600 font-medium">Projects Completed</p>
            </div>
            <div className="group">
              <div className="text-4xl font-bold text-green-600 mb-2 group-hover:scale-110 transition-transform duration-300">
                50+
              </div>
              <p className="text-gray-600 font-medium">Happy Clients</p>
            </div>
            <div className="group">
              <div className="text-4xl font-bold text-purple-600 mb-2 group-hover:scale-110 transition-transform duration-300">
                10+
              </div>
              <p className="text-gray-600 font-medium">Years Experience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
